import { render, staticRenderFns } from "./BaseHeader.vue?vue&type=template&id=cd4b70f0&scoped=true&"
import script from "./BaseHeader.js?vue&type=script&lang=js&"
export * from "./BaseHeader.js?vue&type=script&lang=js&"
import style0 from "./BaseHeader.scss?vue&type=style&index=0&id=cd4b70f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd4b70f0",
  null
  
)

export default component.exports